import { render, staticRenderFns } from "./ArticlePickerPane.vue?vue&type=template&id=ecb27a70&"
import script from "./ArticlePickerPane.vue?vue&type=script&lang=js&"
export * from "./ArticlePickerPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VChipGroup,VRow})
